PersonalizedStore = require '../../../../stores/abstract/PersonalizedStore'
ResponseTimeActionCreator = require './ResponseTimeActionCreator'
ActionTypes = require '../../../../constants/ActionTypes'

actionsMap = 
  "#{ActionTypes.RESPONSE_TIME_STAT_REQUESTING}": ->
    @loading = true
    @error = null
    @emitChange()
  "#{ActionTypes.RESPONSE_TIME_STAT_SUCCESS}": (data) ->
    @loading = false
    @currentRT = data.current_rt
    @shiftRT = data.shift_rt
    @goodRT = data.good_rt
    @channelType = data.channel_type
    @interval = data.interval
    @emitChange()
  "#{ActionTypes.RESPONSE_TIME_STAT_ERROR}": (error) ->
    @loading = false
    @error = error
    @emitChange()


class ResponseTimeStore extends PersonalizedStore
  constructor: ->
    super()
    @loading = false
    @currentRT = null
    @shiftRT = null
    @goodRT = null
    @channelType = {}
    @interval = null
    @error = null
    @registerActions()

  getActionCreator: -> new ResponseTimeActionCreator

  _registerToActions: ({ type, payload, guid }) =>
    return unless @isPersonalAction(guid)
    actionsMap[type].call(@, payload) if actionsMap[type]

module.exports = ResponseTimeStore
